import React from "react";

const QuizTitle = ({title, logo}) => {
    return <div className="quiz__initilal--title">
        {title}
    </div>
};

export default QuizTitle;